import { render, staticRenderFns } from "./SendRequestList.vue?vue&type=template&id=a6381ac6&scoped=true&"
import script from "./SendRequestList.vue?vue&type=script&lang=js&"
export * from "./SendRequestList.vue?vue&type=script&lang=js&"
import style0 from "./SendRequestList.vue?vue&type=style&index=0&id=a6381ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6381ac6",
  null
  
)

export default component.exports